/**
 * Client-side avatar URL resolution.
 *
 * Prefers the stable `/a/<userId>` endpoint (browser + edge cacheable, never
 * expires mid-session) and falls back to whatever URL the caller already has
 * when no user id is available.
 */

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function avatarSrc(
  userId?: string | null,
  fallback?: string | null,
  size = 96,
): string | null {
  if (userId && UUID_RE.test(userId)) return `/a/${userId}?s=${size}`;
  const raw = fallback?.trim();
  return raw ? raw : null;
}
